import { useEffect } from 'react';
import measurementConfig from '../config/measurement';
import { CONSENT_STORAGE_KEY, CONSENT_UPDATED_EVENT, readConsentChoice } from '../utils/analytics';

const GTM_SCRIPT_ID = 'olgun-google-tag-manager';

function loadGoogleTagManager(gtmId) {
  if (document.getElementById(GTM_SCRIPT_ID)) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': Date.now(),
    event: 'gtm.js'
  });

  const script = document.createElement('script');
  script.id = GTM_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;
  document.head.appendChild(script);
}

const Measurement = () => {
  useEffect(() => {
    if (!measurementConfig.enabled) {
      return undefined;
    }

    const applyChoice = (event) => {
      if (event?.type === 'storage' && event.key !== CONSENT_STORAGE_KEY && event.key !== null) return;
      const choice = readConsentChoice();
      if (choice?.analytics_storage === 'granted' || choice?.ad_storage === 'granted') {
        loadGoogleTagManager(measurementConfig.gtmId);
      }
    };
    applyChoice();
    window.addEventListener(CONSENT_UPDATED_EVENT, applyChoice);
    window.addEventListener('storage', applyChoice);
    return () => {
      window.removeEventListener(CONSENT_UPDATED_EVENT, applyChoice);
      window.removeEventListener('storage', applyChoice);
    };
  }, []);

  return null;
};

export default Measurement;
